import React from 'react'

import Select from 'Components/Select'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class ComboSimpleSaisieLibre extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} title={this.props.title}>
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
              alignItems={'center'}>
          <Grid item xs={6} style={{margin: 0, padding: 5}}>
            <Select style={this.props.style} options={this.props.options} onChange={this.props.onChange}
                    disabled={this.props.disabled || false}
                    value={this.props.infoTiers === true && this.props.data !== undefined ? this.props.data.id : this.props.data}/>
          </Grid>
          <Grid item xs={6} style={{margin: 0, padding: 5}}>
            <Traduction
              onChange={this.props.onChangeComboSimpleSaisieLibre}
              disabled={this.props.disabled || false}
              name={'valeur_text'}
              data={this.props.data !== undefined && this.props.data.valeur_text !== undefined ? this.props.data.valeur_text : []}
              type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
        </Grid>
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboSimple/ComboSimpleSaisieLibre.js